export default __webpack_public_path__ + "static/media/image2-285x406-200x200.390e8d6a.png";